/**
 * Remove base URL and /api/v{X}/ prefix from file URL
 * Works with any API version (v1, v2, v3, etc.)
 */
export function removeApiPrefix(url: string): string {
    if (!url) return '';

    // Remove everything up to and including /api/v{number}/
    return url.replace(/^.*\/api\/v\d+\//, '');
}

export function convertToDownloadableLink(url: string): string {
    if (!url || url === '#') {
        return '#';
    }
    return url.replace('/files/open', '/files/download');
}

export function isUsableConfigUrl(url: string | null | undefined): url is string {
    const value = (url || '').trim();

    return value !== '' && value !== '#' && value.toLowerCase() !== 'file attached';
}

export function isUploadedConfigFileUrl(url: string): boolean {
    return url.includes('/files/open/') || url.includes('/files/download/');
}

/**
 * Get file extension from URL
 */
export function getFileExtension(url: string): string {
    if (!url || url === '#') return '';

    // Extract filename from URL
    const filename = url.split('/').pop() || '';

    // Get extension (everything after the last dot)
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop() || '' : '';
}
